export function isFiniteNumber(value: number | undefined | null): value is number {
	if (value === null || value === undefined) {
		return false;
	}

	return Number.isFinite(value);
}

export function isBetweenInclusive(
	value: number | undefined | null,
	lowerBound: number | undefined,
	upperBound: number | undefined,
): value is number {
	// Must be a finite number
	if (!isFiniteNumber(value)) {
		return false;
	}

	if (lowerBound !== undefined) {
		if (value <= lowerBound) {
			return false;
		}
	}

	if (upperBound !== undefined) {
		if (value >= upperBound) {
			return false;
		}
	}

	return true;
}

export function isBetween(
	value: number | undefined | null,
	lowerBound: number | undefined,
	upperBound: number | undefined,
): value is number {
	// Must be a finite number
	if (!isFiniteNumber(value)) {
		return false;
	}

	if (lowerBound !== undefined) {
		if (value < lowerBound) {
			return false;
		}
	}

	if (upperBound !== undefined) {
		if (value > upperBound) {
			return false;
		}
	}

	return true;
}
